import { appConfig } from '../../../config/customization';

export default {
  container: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 10px'
  },
  switchWrapper: {
    width: 50,
    height: 29,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    transition: 'background ease 0.3s',
    borderWidth: 1,
    borderStyle: 'solid'
  },
  containerInactive: {
    borderColor: appConfig.colors.translucentGray,
    backgroundColor: appConfig.colors.lightGray
  },
  containerActive: {
    borderColor: appConfig.colors.green,
    backgroundColor: appConfig.colors.green
  },
  switch: {
    width: 25,
    height: 25,
    background: 'white',
    borderRadius: '100%',
    position: 'absolute',
    transition: 'all ease 0.3s',
    borderWidth: 1,
    borderStyle: 'solid'
  },
  switchInactive: {
    left: 2,
    borderColor: appConfig.colors.translucentGray
  },
  switchActive: {
    left: 22,
    borderColor: appConfig.colors.green
  },
  switchText: {
    width: 24,
    marginLeft: 10
  }
};
